import { 
// backgroundColor,
textColor } from "./colors";
export const textFieldStyle = {
    '& *': {
        color: textColor + '!important',
        borderColor: textColor + '!important',
    },
    '& ::before': {
        color: textColor + '!important',
        borderColor: textColor + '!important',
    },
    '& ::after': {
        color: textColor + '!important',
        borderColor: textColor + '!important',
    },
};
export const postCardStyle = {
    '& .MuiPaper-root': {
    // backgroundColor: '#080b1288',
    },
    backgroundColor: 'rgba(31,53,65,0.53)',
    // backgroundColor: 'transparent',
    // backgroundColor: '#080b1288',
    // backgroundImage: `linear-gradient(140deg, rgba(28, 38, 62, 0.5) 0%, rgba(188, 112, 164, 0.5) 50%, rgba(191, 214, 65, 0.5) 75%)`,
    boxShadow: "3px 8px 15px 2px #000000",
    borderRadius: '10px',
};
export const postCardMobileStyle = {
    ...postCardStyle,
    backgroundColor: 'rgba(31,53,65,0.2)',
};
export const pageStyle = {
    paddingLeft: 1,
    paddingRight: 1,
    // backgroundColor,
    paddingBottom: 10,
    width: '100%',
    margin: 0,
};
export const sidebarStyle = {
    height: '100%',
    color: textColor + '!important',
    borderColor: textColor + '!important',
    backgroundColor: '#0304086e',
    backgroundImage: 'linear-gradient(45deg, black, transparent)',
    '& *': {
        color: textColor + '!important',
        borderColor: textColor + '!important',
    },
};
export const accountStyles = {
    ...textFieldStyle,
    width: '100%',
    height: '100%',
    color: textColor + '!important',
    borderColor: textColor + '!important',
    // backgroundColor,
};
//# sourceMappingURL=styles.js.map